import { makeValuesPredicate } from '@sgme/fp';
import { createIntl, createIntlCache } from 'react-intl';

import de from './global.de.json' with { type: 'json' };
import en from './global.en.json' with { type: 'json' };
import fr from './global.fr.json' with { type: 'json' };
import it from './global.it.json' with { type: 'json' };
import ja from './global.ja.json' with { type: 'json' };

const all = { en, fr, de, it, ja };

export const langs = Object.keys(all) as LanguageIsoCode[];
export const isAllowedLang = makeValuesPredicate(langs);
export type LanguageIsoCode = keyof typeof all;
export const defaultLanguage: LanguageIsoCode = 'en';

export default all;
export function getMessages(locale: LanguageIsoCode): Record<IntlKey, string> {
  const enMessages = all[defaultLanguage];
  const allMessages = locale === defaultLanguage ? enMessages : { ...enMessages, ...all[locale] };
  return allMessages as Record<IntlKey, string>;
}

const cache = createIntlCache();

export function getIntl(locale: LanguageIsoCode) {
  return createIntl(
    {
      locale,
      messages: all[locale] as Record<IntlKey, string>,
      defaultLocale: 'en',
      defaultFormats: {},
    },
    cache,
  );
}

export type IntlKey = keyof typeof en;
export type KeyPrefix<AllKeys extends string, KeySuffix extends string> = {
  [P in AllKeys]: P extends `${infer KeyPrefix}${KeySuffix}` ? KeyPrefix : never;
}[AllKeys];
export type KeySuffix<AllKeys extends string, KeyPrefix extends string> = {
  [P in AllKeys]: P extends `${KeyPrefix}${infer KeySuffix}` ? KeySuffix : never;
}[AllKeys];

declare global {
  namespace FormatjsIntl {
    interface Message {
      ids: IntlKey;
    }
  }
}
